import { render } from "./SnsConnectModal.vue?vue&type=template&id=3c4a94a2&lang=true"
import script from "./SnsConnectModal.vue?vue&type=script&lang=js"
export * from "./SnsConnectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__